export type Color = {
  id: string;
  label?: string;
  value: string;
  subGroupId?: string;
};

export type ColorGroups = {
  id: string;
  label: string;
  colors: Color[];
  subGroups?: { id: string; label: string; hideDivider?: boolean; className?: string }[];
};

export const whiteBlack = [
  {
    id: 'bg-transparent',
    value: 'transparent',
    label: 'Transparent',
  },
  { id: 'bg-primary', value: '--bg-primary', label: 'White' },
  { id: 'bg-primary_inverse', value: '--bg-primary_inverse', label: 'Black' },
];

export const primaryColor = [
  // gray colors
  { id: 'bg-solid-secondary', value: '--bg-solid-secondary', label: 'Gray 600' },
  { id: 'bg-overlay', value: '--bg-overlay', label: 'Gray 950' },
  { id: 'bg-darker', value: '--bg-darker', label: 'Gray 900' },
  { id: 'bg-dark', value: '--bg-dark', label: 'Gray 800' },
  { id: 'bg-strong', value: '--bg-strong', label: 'Gray 700' },
  { id: 'bg-medium', value: '--bg-medium', label: 'Gray 500' },
  { id: 'bg-mild', value: '--bg-mild', label: 'Gray 400' },
  { id: 'bg-quaternary', value: '--bg-quaternary', label: 'Gray 300' },
  { id: 'bg-tertiary', value: '--bg-tertiary', label: 'Gray 200' },
  { id: 'bg-secondary', value: '--bg-secondary', label: 'Gray 100' },
  // todo: ask about this, since now there is a clash of values
  { id: 'bg-secondary', value: '--bg-secondary', label: 'Gray 50' },
  { id: 'bg-lightest', value: '--bg-lightest', label: 'Gray 25' },

  // brand colors
  { id: 'bg-brand-solid', value: '--bg-brand-solid', label: 'Brand 600' },
  { id: 'bg-brand-darkest', value: '--bg-brand-darkest', label: 'Brand 950' },
  { id: 'bg-brand-darker', value: '--bg-brand-darker', label: 'Brand 900' },
  { id: 'bg-utility-brand-800', value: '--utility-brand-800', label: 'Brand 800' },
  { id: 'bg-utility-brand-700', value: '--utility-brand-700', label: 'Brand 700' },
  { id: 'bg-brand-medium', value: '--bg-brand-medium', label: 'Brand 500' },
  { id: 'bg-brand-mild', value: '--bg-brand-mild', label: 'Brand 400' },
  { id: 'bg-brand-soft', value: '--bg-brand-soft', label: 'Brand 300' },
  { id: 'bg-brand-tertiary', value: '--bg-brand-tertiary', label: 'Brand 200' },
  { id: 'bg-brand-secondary', value: '--bg-brand-secondary', label: 'Brand 100' },
  { id: 'bg-brand-primary', value: '--bg-brand-primary', label: 'Brand 50' },
  { id: 'bg-utility-brand-25', value: '--bg-utility-brand-25', label: 'Brand 25' },

  // brand secondary colors
  {
    id: 'bg-palette-brand-secondary-600',
    value: '--palette-brand-secondary-600',
    label: 'Brand Secondary 600',
  },
  {
    id: 'bg-palette-brand-secondary-950',
    value: '--palette-brand-secondary-950',
    label: 'Brand Secondary 950',
  },
  {
    id: 'bg-palette-brand-secondary-900',
    value: '--palette-brand-secondary-900',
    label: 'Brand Secondary 900',
  },
  {
    id: 'bg-palette-brand-secondary-800',
    value: '--palette-brand-secondary-800',
    label: 'Brand Secondary 800',
  },
  {
    id: 'bg-palette-brand-secondary-700',
    value: '--palette-brand-secondary-700',
    label: 'Brand Secondary 700',
  },
  {
    id: 'bg-palette-brand-secondary-500',
    value: '--palette-brand-secondary-500',
    label: 'Brand Secondary 500',
  },
  {
    id: 'bg-palette-brand-secondary-400',
    value: '--palette-brand-secondary-400',
    label: 'Brand Secondary 400',
  },
  {
    id: 'bg-palette-brand-secondary-300',
    value: '--palette-brand-secondary-300',
    label: 'Brand Secondary 300',
  },
  {
    id: 'bg-palette-brand-secondary-200',
    value: '--palette-brand-secondary-200',
    label: 'Brand Secondary 200',
  },
  {
    id: 'bg-palette-brand-secondary-100',
    value: '--palette-brand-secondary-100',
    label: 'Brand Secondary 100',
  },
  {
    id: 'bg-palette-brand-secondary-50',
    value: '--palette-brand-secondary-50',
    label: 'Brand Secondary 50',
  },
  {
    id: 'bg-palette-brand-secondary-25',
    value: '--palette-brand-secondary-25',
    label: 'Brand Secondary 25',
  },

  //success
  { id: 'bg-palette-success-600', value: '--palette-success-600', label: 'Success 600' },
  { id: 'bg-palette-success-950', value: '--palette-success-950', label: 'Success 950' },
  { id: 'bg-palette-success-900', value: '--palette-success-900', label: 'Success 900' },
  { id: 'bg-palette-success-800', value: '--palette-success-800', label: 'Success 800' },
  { id: 'bg-palette-success-700', value: '--palette-success-700', label: 'Success 700' },
  { id: 'bg-palette-success-500', value: '--palette-success-500', label: 'Success 500' },
  { id: 'bg-palette-success-400', value: '--palette-success-400', label: 'Success 400' },
  { id: 'bg-palette-success-300', value: '--palette-success-300', label: 'Success 300' },
  { id: 'bg-palette-success-200', value: '--palette-success-200', label: 'Success 200' },
  { id: 'bg-palette-success-100', value: '--palette-success-100', label: 'Success 100' },
  { id: 'bg-palette-success-50', value: '--palette-success-50', label: 'Success 50' },
  { id: 'bg-palette-success-25', value: '--palette-success-25', label: 'Success 25' },

  //error
  { id: 'bg-palette-error-600', value: '--palette-error-600', label: 'Error 600' },
  { id: 'bg-palette-error-950', value: '--palette-error-950', label: 'Error 950' },
  { id: 'bg-palette-error-900', value: '--palette-error-900', label: 'Error 900' },
  { id: 'bg-palette-error-800', value: '--palette-error-800', label: 'Error 800' },
  { id: 'bg-palette-error-700', value: '--palette-error-700', label: 'Error 700' },
  { id: 'bg-palette-error-500', value: '--palette-error-500', label: 'Error 500' },
  { id: 'bg-palette-error-400', value: '--palette-error-400', label: 'Error 400' },
  { id: 'bg-palette-error-300', value: '--palette-error-300', label: 'Error 300' },
  { id: 'bg-palette-error-200', value: '--palette-error-200', label: 'Error 200' },
  { id: 'bg-palette-error-100', value: '--palette-error-100', label: 'Error 100' },
  { id: 'bg-palette-error-50', value: '--palette-error-50', label: 'Error 50' },
  { id: 'bg-palette-error-25', value: '--palette-error-25', label: 'Error 25' },

  //warning
  { id: 'bg-palette-warning-600', value: '--palette-warning-600', label: 'Warning 600' },
  { id: 'bg-palette-warning-950', value: '--palette-warning-950', label: 'Warning 950' },
  { id: 'bg-palette-warning-900', value: '--palette-warning-900', label: 'Warning 900' },
  { id: 'bg-palette-warning-800', value: '--palette-warning-800', label: 'Warning 800' },
  { id: 'bg-palette-warning-700', value: '--palette-warning-700', label: 'Warning 700' },
  { id: 'bg-palette-warning-500', value: '--palette-warning-500', label: 'Warning 500' },
  { id: 'bg-palette-warning-400', value: '--palette-warning-400', label: 'Warning 400' },
  { id: 'bg-palette-warning-300', value: '--palette-warning-300', label: 'Warning 300' },
  { id: 'bg-palette-warning-200', value: '--palette-warning-200', label: 'Warning 200' },
  { id: 'bg-palette-warning-100', value: '--palette-warning-100', label: 'Warning 100' },
  { id: 'bg-palette-warning-50', value: '--palette-warning-50', label: 'Warning 50' },
  { id: 'bg-palette-warning-25', value: '--palette-warning-25', label: 'Warning 25' },
];

export const accentColors = [
  {
    id: 'bg-palette-lime-green-600',
    value: '--palette-lime-green-600',
    label: 'Lime Green 600',
  },
  {
    id: 'bg-palette-lime-green-950',
    value: '--palette-lime-green-950',
    label: 'Lime Green 950',
  },
  {
    id: 'bg-palette-lime-green-900',
    value: '--palette-lime-green-900',
    label: 'Lime Green 900',
  },
  {
    id: 'bg-palette-lime-green-800',
    value: '--palette-lime-green-800',
    label: 'Lime Green 800',
  },
  {
    id: 'bg-palette-lime-green-700',
    value: '--palette-lime-green-700',
    label: 'Lime Green 700',
  },
  {
    id: 'bg-palette-lime-green-500',
    value: '--palette-lime-green-500',
    label: 'Lime Green 500',
  },
  {
    id: 'bg-palette-lime-green-400',
    value: '--palette-lime-green-400',
    label: 'Lime Green 400',
  },
  {
    id: 'bg-palette-lime-green-300',
    value: '--palette-lime-green-300',
    label: 'Lime Green 300',
  },
  {
    id: 'bg-palette-lime-green-200',
    value: '--palette-lime-green-200',
    label: 'Lime Green 200',
  },
  {
    id: 'bg-palette-lime-green-100',
    value: '--palette-lime-green-100',
    label: 'Lime Green 100',
  },
  { id: 'bg-palette-lime-green-50', value: '--palette-lime-green-50', label: 'Lime Green 50' },
  { id: 'bg-palette-lime-green-25', value: '--palette-lime-green-25', label: 'Lime Green 25' },
  { id: 'bg-palette-teal-600', value: '--palette-teal-600', label: 'Teal 600' },
  { id: 'bg-palette-teal-950', value: '--palette-teal-950', label: 'Teal 950' },
  { id: 'bg-palette-teal-900', value: '--palette-teal-900', label: 'Teal 900' },
  { id: 'bg-palette-teal-800', value: '--palette-teal-800', label: 'Teal 800' },
  { id: 'bg-palette-teal-700', value: '--palette-teal-700', label: 'Teal 700' },
  { id: 'bg-palette-teal-500', value: '--palette-teal-500', label: 'Teal 500' },
  { id: 'bg-palette-teal-400', value: '--palette-teal-400', label: 'Teal 400' },
  { id: 'bg-palette-teal-300', value: '--palette-teal-300', label: 'Teal 300' },
  { id: 'bg-palette-teal-200', value: '--palette-teal-200', label: 'Teal 200' },
  { id: 'bg-palette-teal-100', value: '--palette-teal-100', label: 'Teal 100' },
  { id: 'bg-palette-teal-50', value: '--palette-teal-50', label: 'Teal 50' },
  { id: 'bg-palette-teal-25', value: '--palette-teal-25', label: 'Teal 25' },
  { id: 'bg-palette-cyan-600', value: '--palette-cyan-600', label: 'Cyan 600' },
  { id: 'bg-palette-cyan-950', value: '--palette-cyan-950', label: 'Cyan 950' },
  { id: 'bg-palette-cyan-900', value: '--palette-cyan-900', label: 'Cyan 900' },
  { id: 'bg-palette-cyan-800', value: '--palette-cyan-800', label: 'Cyan 800' },
  { id: 'bg-palette-cyan-700', value: '--palette-cyan-700', label: 'Cyan 700' },
  { id: 'bg-palette-cyan-500', value: '--palette-cyan-500', label: 'Cyan 500' },
  { id: 'bg-palette-cyan-400', value: '--palette-cyan-400', label: 'Cyan 400' },
  { id: 'bg-palette-cyan-300', value: '--palette-cyan-300', label: 'Cyan 300' },
  { id: 'bg-palette-cyan-200', value: '--palette-cyan-200', label: 'Cyan 200' },
  { id: 'bg-palette-cyan-100', value: '--palette-cyan-100', label: 'Cyan 100' },
  { id: 'bg-palette-cyan-50', value: '--palette-cyan-50', label: 'Cyan 50' },
  { id: 'bg-palette-cyan-25', value: '--palette-cyan-25', label: 'Cyan 25' },
  { id: 'bg-palette-blue-600', value: '--palette-blue-600', label: 'Blue 600' },
  { id: 'bg-palette-blue-950', value: '--palette-blue-950', label: 'Blue 950' },
  { id: 'bg-palette-blue-900', value: '--palette-blue-900', label: 'Blue 900' },
  { id: 'bg-palette-blue-800', value: '--palette-blue-800', label: 'Blue 800' },
  { id: 'bg-palette-blue-700', value: '--palette-blue-700', label: 'Blue 700' },
  { id: 'bg-palette-blue-500', value: '--palette-blue-500', label: 'Blue 500' },
  { id: 'bg-palette-blue-400', value: '--palette-blue-400', label: 'Blue 400' },
  { id: 'bg-palette-blue-300', value: '--palette-blue-300', label: 'Blue 300' },
  { id: 'bg-palette-blue-200', value: '--palette-blue-200', label: 'Blue 200' },
  { id: 'bg-palette-blue-100', value: '--palette-blue-100', label: 'Blue 100' },
  { id: 'bg-palette-blue-50', value: '--palette-blue-50', label: 'Blue 50' },
  { id: 'bg-palette-blue-25', value: '--palette-blue-25', label: 'Blue 25' },
  { id: 'bg-palette-blue-dark-600', value: '--palette-blue-dark-600', label: 'Dark Blue 600' },
  { id: 'bg-palette-blue-dark-950', value: '--palette-blue-dark-950', label: 'Dark Blue 950' },
  { id: 'bg-palette-blue-dark-900', value: '--palette-blue-dark-900', label: 'Dark Blue 900' },
  { id: 'bg-palette-blue-dark-800', value: '--palette-blue-dark-800', label: 'Dark Blue 800' },
  { id: 'bg-palette-blue-dark-700', value: '--palette-blue-dark-700', label: 'Dark Blue 700' },
  { id: 'bg-palette-blue-dark-500', value: '--palette-blue-dark-500', label: 'Dark Blue 500' },
  { id: 'bg-palette-blue-dark-400', value: '--palette-blue-dark-400', label: 'Dark Blue 400' },
  { id: 'bg-palette-blue-dark-300', value: '--palette-blue-dark-300', label: 'Dark Blue 300' },
  { id: 'bg-palette-blue-dark-200', value: '--palette-blue-dark-200', label: 'Dark Blue 200' },
  { id: 'bg-palette-blue-dark-100', value: '--palette-blue-dark-100', label: 'Dark Blue 100' },
  { id: 'bg-palette-blue-dark-50', value: '--palette-blue-dark-50', label: 'Dark Blue 50' },
  { id: 'bg-palette-blue-dark-25', value: '--palette-blue-dark-25', label: 'Dark Blue 25' },
  { id: 'bg-palette-indigo-600', value: '--palette-indigo-600', label: 'Indigo 600' },
  { id: 'bg-palette-indigo-950', value: '--palette-indigo-950', label: 'Indigo 950' },
  { id: 'bg-palette-indigo-900', value: '--palette-indigo-900', label: 'Indigo 900' },
  { id: 'bg-palette-indigo-800', value: '--palette-indigo-800', label: 'Indigo 800' },
  { id: 'bg-palette-indigo-700', value: '--palette-indigo-700', label: 'Indigo 700' },
  { id: 'bg-palette-indigo-500', value: '--palette-indigo-500', label: 'Indigo 500' },
  { id: 'bg-palette-indigo-400', value: '--palette-indigo-400', label: 'Indigo 400' },
  { id: 'bg-palette-indigo-300', value: '--palette-indigo-300', label: 'Indigo 300' },
  { id: 'bg-palette-indigo-200', value: '--palette-indigo-200', label: 'Indigo 200' },
  { id: 'bg-palette-indigo-100', value: '--palette-indigo-100', label: 'Indigo 100' },
  { id: 'bg-palette-indigo-50', value: '--palette-indigo-50', label: 'Indigo 50' },
  { id: 'bg-palette-indigo-25', value: '--palette-indigo-25', label: 'Indigo 25' },
  { id: 'bg-palette-violet-600', value: '--palette-violet-600', label: 'Violet 600' },
  { id: 'bg-palette-violet-950', value: '--palette-violet-950', label: 'Violet 950' },
  { id: 'bg-palette-violet-900', value: '--palette-violet-900', label: 'Violet 900' },
  { id: 'bg-palette-violet-800', value: '--palette-violet-800', label: 'Violet 800' },
  { id: 'bg-palette-violet-700', value: '--palette-violet-700', label: 'Violet 700' },
  { id: 'bg-palette-violet-500', value: '--palette-violet-500', label: 'Violet 500' },
  { id: 'bg-palette-violet-400', value: '--palette-violet-400', label: 'Violet 400' },
  { id: 'bg-palette-violet-300', value: '--palette-violet-300', label: 'Violet 300' },
  { id: 'bg-palette-violet-200', value: '--palette-violet-200', label: 'Violet 200' },
  { id: 'bg-palette-violet-100', value: '--palette-violet-100', label: 'Violet 100' },
  { id: 'bg-palette-violet-50', value: '--palette-violet-50', label: 'Violet 50' },
  { id: 'bg-palette-violet-25', value: '--palette-violet-25', label: 'Violet 25' },
  { id: 'bg-palette-fuchsia-600', value: '--palette-fuchsia-600', label: 'Fuchsia 600' },
  { id: 'bg-palette-fuchsia-950', value: '--palette-fuchsia-950', label: 'Fuchsia 950' },
  { id: 'bg-palette-fuchsia-900', value: '--palette-fuchsia-900', label: 'Fuchsia 900' },
  { id: 'bg-palette-fuchsia-800', value: '--palette-fuchsia-800', label: 'Fuchsia 800' },
  { id: 'bg-palette-fuchsia-700', value: '--palette-fuchsia-700', label: 'Fuchsia 700' },
  { id: 'bg-palette-fuchsia-500', value: '--palette-fuchsia-500', label: 'Fuchsia 500' },
  { id: 'bg-palette-fuchsia-400', value: '--palette-fuchsia-400', label: 'Fuchsia 400' },
  { id: 'bg-palette-fuchsia-300', value: '--palette-fuchsia-300', label: 'Fuchsia 300' },
  { id: 'bg-palette-fuchsia-200', value: '--palette-fuchsia-200', label: 'Fuchsia 200' },
  { id: 'bg-palette-fuchsia-100', value: '--palette-fuchsia-100', label: 'Fuchsia 100' },
  { id: 'bg-palette-fuchsia-50', value: '--palette-fuchsia-50', label: 'Fuchsia 50' },
  { id: 'bg-palette-fuchsia-25', value: '--palette-fuchsia-25', label: 'Fuchsia 25' },
  { id: 'bg-palette-pink-600', value: '--palette-pink-600', label: 'Pink 600' },
  { id: 'bg-palette-pink-950', value: '--palette-pink-950', label: 'Pink 950' },
  { id: 'bg-palette-pink-900', value: '--palette-pink-900', label: 'Pink 900' },
  { id: 'bg-palette-pink-800', value: '--palette-pink-800', label: 'Pink 800' },
  { id: 'bg-palette-pink-700', value: '--palette-pink-700', label: 'Pink 700' },
  { id: 'bg-palette-pink-500', value: '--palette-pink-500', label: 'Pink 500' },
  { id: 'bg-palette-pink-400', value: '--palette-pink-400', label: 'Pink 400' },
  { id: 'bg-palette-pink-300', value: '--palette-pink-300', label: 'Pink 300' },
  { id: 'bg-palette-pink-200', value: '--palette-pink-200', label: 'Pink 200' },
  { id: 'bg-palette-pink-100', value: '--palette-pink-100', label: 'Pink 100' },
  { id: 'bg-palette-pink-50', value: '--palette-pink-50', label: 'Pink 50' },
  { id: 'bg-palette-pink-25', value: '--palette-pink-25', label: 'Pink 25' },
  { id: 'bg-palette-rose-600', value: '--palette-rose-600', label: 'Rose 600' },
  { id: 'bg-palette-rose-950', value: '--palette-rose-950', label: 'Rose 950' },
  { id: 'bg-palette-rose-900', value: '--palette-rose-900', label: 'Rose 900' },
  { id: 'bg-palette-rose-800', value: '--palette-rose-800', label: 'Rose 800' },
  { id: 'bg-palette-rose-700', value: '--palette-rose-700', label: 'Rose 700' },
  { id: 'bg-palette-rose-500', value: '--palette-rose-500', label: 'Rose 500' },
  { id: 'bg-palette-rose-400', value: '--palette-rose-400', label: 'Rose 400' },
  { id: 'bg-palette-rose-300', value: '--palette-rose-300', label: 'Rose 300' },
  { id: 'bg-palette-rose-200', value: '--palette-rose-200', label: 'Rose 200' },
  { id: 'bg-palette-rose-100', value: '--palette-rose-100', label: 'Rose 100' },
  { id: 'bg-palette-rose-50', value: '--palette-rose-50', label: 'Rose 50' },
  { id: 'bg-palette-rose-25', value: '--palette-rose-25', label: 'Rose 25' },
  { id: 'bg-palette-orange-600', value: '--palette-orange-600', label: 'Orange 600' },
  { id: 'bg-palette-orange-950', value: '--palette-orange-950', label: 'Orange 950' },
  { id: 'bg-palette-orange-900', value: '--palette-orange-900', label: 'Orange 900' },
  { id: 'bg-palette-orange-800', value: '--palette-orange-800', label: 'Orange 800' },
  { id: 'bg-palette-orange-700', value: '--palette-orange-700', label: 'Orange 700' },
  { id: 'bg-palette-orange-500', value: '--palette-orange-500', label: 'Orange 500' },
  { id: 'bg-palette-orange-400', value: '--palette-orange-400', label: 'Orange 400' },
  { id: 'bg-palette-orange-300', value: '--palette-orange-300', label: 'Orange 300' },
  { id: 'bg-palette-orange-200', value: '--palette-orange-200', label: 'Orange 200' },
  { id: 'bg-palette-orange-100', value: '--palette-orange-100', label: 'Orange 100' },
  { id: 'bg-palette-orange-50', value: '--palette-orange-50', label: 'Orange 50' },
  { id: 'bg-palette-orange-25', value: '--palette-orange-25', label: 'Orange 25' },
];

export const backgroundColor = [
  ...whiteBlack.map((color) => ({ ...color, subGroupId: 'whiteBlack' })),
  ...primaryColor.map((color) => ({ ...color, subGroupId: 'primaryColor' })),
  ...accentColors.map((color) => ({ ...color, subGroupId: 'accentColor' })),
];

export const gradientColor = [
  {
    id: 'gradient-brand',
    value: '--gradient-brand',
    label: 'Primary Brand',
  },
  {
    id: 'gradient-primary',
    value: '--gradient-primary',
    label: 'Primary Gradient',
  },
  {
    id: 'gradient-error',
    value: '--gradient-error',
    label: 'Error Gradient',
  },
  {
    id: 'gradient-warning',
    value: '--gradient-warning',
    label: 'Warning Gradient',
  },

  {
    id: 'gradient-success',
    value: '--gradient-success',
    label: 'Success Gradient',
  },
  {
    id: 'gradient-secondary',
    value: '--gradient-secondary',
    label: 'Secondary Gradient',
  },
  {
    id: 'gradient-tertiary',
    value: '--gradient-tertiary',
    label: 'Tertiary Gradient',
  },
  {
    id: 'gradient-neutral',
    value: '--gradient-neutral',
    label: 'Neutral Gradient',
  },
  {
    id: 'gradient-cool',
    value: '--gradient-cool',
    label: 'Cool Gradient',
  },
  {
    id: 'gradient-light',
    value: '--gradient-light',
    label: 'Light Gradient',
  },
  {
    id: 'gradient-blue',
    value: '--gradient-blue',
    label: 'Blue Gradient',
  },
  {
    id: 'gradient-yellow',
    value: '--gradient-yellow',
    label: 'Yellow Gradient',
  },
  {
    id: 'gradient-red',
    value: '--gradient-red',
    label: 'Red Gradient',
  },
  {
    id: 'bg-rainbow',
    value: '--gradient-rainbow',
    label: 'Rainbow Gradient',
  },
];

export const backgroundColorGroups: ColorGroups[] = [
  {
    id: 'backgroundColor',
    label: 'Solid',
    subGroups: [
      {
        id: 'whiteBlack',
        label: '',
        hideDivider: true,
        className: 'py-xs',
      },
      {
        id: 'primaryColor',
        label: '',
      },
      {
        id: 'accentColor',
        label: '',
      },
    ],
    colors: backgroundColor,
  },
  {
    id: 'backgroundGradient',
    label: 'Gradients',
    colors: gradientColor,
  },
];
